export default function() {
  let ctrl = function($stateParams, surveyService, $sce) {
    "ngInject";

    const moment = require("moment");

    const vm = this;

    const languages = surveyService.getLanguageKeys();

    vm.lang = languages.indexOf($stateParams.lang) == -1 ? "eng" : $stateParams.lang;

    vm.title = surveyService.getSurvey().title;

    vm.customMessage = surveyService.getSurvey().confirmationPageMessage;
    vm.customHtml = surveyService.getSurvey().confirmationPageHtml;
    vm.showDate = !!surveyService.getSurvey().confirmationPageShowDate;
    vm.date = `Date/Time: ${moment().format("LLL")}`;
    vm.trustedHtml = (plainText) => $sce.trustAsHtml(plainText);
   
  };

  const template = `
        <div class="survey-header">
            <a href="http://safeandreliablecare.com" target="_blank">
                <img src="/logo.svg">
            </a>
        </div>
        <div class="survey-body" style="text-align:center">
            <div ng-if="!confirmation.customHtml">
                <h1 ng-bind-html="confirmation.title[confirmation.lang]"></h1>
                <div class="fade-in" style="background: #2980b9; border-radius: 50%; width: 140px; height: 140px; margin: 40px auto"></div>
                <i ng-cloak class="material-icons" style="color: #fff; font-size: 80px; cursor: default; position: relative; top: -150px; display: block; height: 0">thumb_up</i>
                <p ng-if="!confirmation.customMessage" style="margin:0">Thank you for taking the time to complete this survey.</p>
                <p ng-if="confirmation.customMessage" style="margin:0;white-space:pre" ng-bind="confirmation.customMessage"></p>
            </div>
            <div ng-if="confirmation.customHtml" ng-bind-html="confirmation.trustedHtml(confirmation.customHtml)"></div>
            <div ng-if="confirmation.showDate">
              <br>
              <p ng-bind="confirmation.date" style="font-size:14px"></p>
            </div>
        </div>
    `;

  return {
    restrict: "E",
    scope: {
      saved: "=",
    },
    template: template,
    controller: ctrl,
    controllerAs: "confirmation",
  };
}



// WEBPACK FOOTER //
// ./app/components/survey-confirmation/survey-confirmation.directive.js